<script>
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';

	import {
		AddPrivacySolution,
		BlockColdSolution,
		BlockHeatSolution,
		BlockLightSolution,
		BlockNoiseSolution,
		BlockPollutantsSolution,
		BlockUVSolution,
		EnergyEfficiencySolution,
		HistoricWindowsSolution,
		PreventCondensationSolution,
		SaveMoneySolution,
		SpecialtyShapesSolution,
	} from '$lib/data/solutions/solutions-data';

	import CommercialInsulation from '$lib/PageSections/CommercialInsulation/CommercialInsulation.svelte';
	import IndowPerformance from '$lib/PageSections/IndowPerformance/IndowPerformance.svelte';
	import TrustedChoice from '$lib/PageSections/TrustedChoice/TrustedChoice.svelte';

	const solutions = [
		BlockNoiseSolution,
		BlockColdSolution,
		BlockHeatSolution,
		SaveMoneySolution,
		EnergyEfficiencySolution,
		PreventCondensationSolution,
		BlockUVSolution,
		BlockLightSolution,
		AddPrivacySolution,
		BlockPollutantsSolution,
		HistoricWindowsSolution,
		SpecialtyShapesSolution,
	];
</script>

<Section>
	<h2 class="text-left">A Solution For Every Window</h2>

	<p class="text-left">
		No matter what issues you face, Indow inserts are the most versatile,
		affordable, and hassle-free way to keep unwelcome annoyances outside without
		blocking light from your windows - or investing in expensive window
		replacements.
	</p>

	<ul
		class="
    grid list-none grid-cols-3
    sm:grid-cols-3
    md:grid-cols-4
  "
	>
		{#each solutions as { src, title, href }, index (index)}
			<li
				class="
      rounded-md py-4
      hover:bg-gray-100
    "
			>
				<a {href}>
					<p class="grid gap-3 text-center font-medium text-indow-grey-dark">
						<span class="h-20 w-auto text-indow-blue">
							{@render src()}
						</span>
						{title}
					</p>
				</a>
			</li>
		{/each}
	</ul>

	<p class="text-left">
		Every Indow inserts provides superior noise reduction and boosts energy
		savings through every season - keeping cold air out in the winter and hot
		air in the summer.
	</p>

	<CommercialInsulation />
</Section>

<IndowPerformance />
<TrustedChoice />
<Reviews />
<GetAFreeEstimate />
